module.exports = __webpack_public_path__ + "img/ico-japan_BIG.6aaaed52.png";